<section *ngIf="!isOpened">
  <div class="row">
    <div class="col-12 col-sm-12">
      <form class="needs-validation container-style" novalidate [formGroup]="formMasterSolution">
        <div class="ps-2 pe-2">
          <div class="row pt-1">
            <div class="col">
              <app-custom-button [title]="'Regresar'" [icon]="'pi pi-arrow-left'" [link]="true" [label]="'Regresar'"
                [width]="'6rem'" [routerLink]="['/', url]" [severity]="null"></app-custom-button>
            </div>
            <div class="col d-flex justify-content-sm-center justify-content-end align-items-center">
              <app-navigation (buttonClick)="getButtonClick($event)"></app-navigation>
            </div>

            <div class="col mt-2 mt-sm-0 gap-1 d-flex justify-content-md-end justify-content-center">
              <app-custom-button [title]="'Eliminar'" [icon]="'pi pi-trash'" [severity]="'contrast'"
                (onClick)="delete()"></app-custom-button>

              <app-custom-button class="ms-2" [title]="'Nuevo'" [label]="'Nuevo'" [icon]="'pi pi-plus'"
                [width]="'5.5rem'" [severity]="'success'" [variant]="undefined"
                (onClick)="createNewRegister()"></app-custom-button>
            </div>
            <hr class="my-1">
          </div>
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-12">
              <app-custom-audit-info [userNameCreate]="masterSolutionContract.userNameCreate"
                [createDate]="masterSolutionContract.createDate"
                [userNameUpdate]="masterSolutionContract.userNameUpdate"
                [updateDate]="masterSolutionContract.updateDate"
                [reserveSpace]="true"></app-custom-audit-info>
            </div>
          </div>
        </div>
        <div class="row p-2">
          <div class="col-lg-12 col-12">
            <div class="row d-flex align-items-start">
              <div class="col-lg-2 col-md-3 col-sm-4 col-12">
                <app-custom-select formControlName="branchId" [labelText]="'Sucursal'" [list]="listBranches"
                  [required]="true" [recovery]="true" (onChangeSelect)="changeBranch($event)"></app-custom-select>
              </div>
              <div class="col-lg-1 col-md-2 col-sm-2 col-12">
                <app-custom-input-number formControlName="consecutive" [labelText]="'Número'" [required]="true"
                  [recovery]="true" (onChangeNumber)="changeConsecutive($event)"></app-custom-input-number>
              </div>
              <div class="col-lg-1 col-md-2 col-sm-2 col-12">
                <app-custom-input-text formControlName="alterCode" [labelText]="'Cod.Alt'"
                  [maxLength]="10"></app-custom-input-text>
              </div>
              <div class="col-lg-2 col-md-5 col-sm-4 col-12">
                <app-custom-textarea formControlName="name" [labelText]="'Nombre Solución'" [autoResize]="false"
                  [required]="true" [rows]="1" [maxLength]="1000"></app-custom-textarea>
              </div>
              <div class="col-lg-3 col-md-5 col-sm-6 col-12">
                <app-custom-textarea formControlName="description" [labelText]="'Descripción'" [autoResize]="false"
                  [required]="true" [rows]="1" [maxLength]="1000"></app-custom-textarea>
              </div>
              <div class="col-lg-1 col-md-2 col-sm-2 col-10">
                <app-custom-tag [label]="'Estado'" [severity]="severityState" [value]="stateMasterSolution">
                </app-custom-tag>
              </div>
              <div class="col field-button">
                <app-custom-button [title]="titleState" [icon]="iconState" [severity]="'primary'"
                  (onClick)="changeState()">
                </app-custom-button>
              </div>
              <div class="col-lg-12 col-md-12 col-12 d-flex justify-content-end mt-2">
                <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [severity]="'primary'" [variant]="undefined"
                  [disabled]="disabledForm" (onClick)="send()">
                </app-custom-button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <app-master-solution-detail [masterSolutionModel]="masterSolutionContract" [disabledForm]="disabledForm"
      [permissionUpdatable]="permissionUpdatable" [permissionsUser]="permissionsUser"
      [userAuthenticated]="userAuthenticated" (emitQuantityDetails)="quantityDetails = $event">
    </app-master-solution-detail>
  </div>
</section>
<!-- Mensaje de duplicidad ventanas abiertas -->
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1"> highlight_off </span>
  <h6>No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>